import { render } from "./value.vue?vue&type=template&id=9d5e85ec&scoped=true"
import script from "./value.vue?vue&type=script&lang=js"
export * from "./value.vue?vue&type=script&lang=js"

import "./value.vue?vue&type=style&index=0&id=9d5e85ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9d5e85ec"

export default script